import {
  colors,
  Icons,
  ImpButtonProps,
  ImpCard,
  ImpContainer,
  ImpIcon,
  ImpList,
  ImpListItemProps,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { requestPhysicalCard } from '../../api/api';
import { useImpState } from '../../app/hooks';
import { FORM_BUTTON_WIDTH } from '../../assets/consts/const';
import OnboardingLayout from './OnboardingLayout';

interface ListItem {
  icon: string;
  text: string;
}

const getListItemProps = (listItems: ListItem[]): ImpListItemProps[] => {
  return listItems.map((item) => {
    return {
      subtitle: item.text,
      leadingIcon: (
        <ImpIcon iconSrc={Icons[item.icon]} stroke="var(--merchant-color)" />
      ),
    };
  });
};

export interface NewCardCongratsContent {
  title: string;
  subtitle: string;
  listItems: ListItem[];
}

export interface NewCardCongratsPageProps {
  content: NewCardCongratsContent;
  onNext: () => void;
}

export default function NewCardCongratsPage({
  content,
  onNext,
}: NewCardCongratsPageProps) {
  const { language, merchantData, consumerInfo, appStatus, dispatch } =
    useImpState();

  useEffect(() => {
    // Auto-ship physical card
    dispatch(
      requestPhysicalCard(consumerInfo.auth.token, appStatus.productAccountUUID)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleContinue = () => {
    onNext();
  };

  const buttonProps: ImpButtonProps[] = [
    {
      children: language.continueBtn,
      variant: 'primary',
      buttonStyle: 'branded',
      onClick: handleContinue,
    },
  ];

  return (
    <OnboardingLayout bottomButtons={buttonProps}>
      <ImpSpacer height="l" />
      <ImpCard src={merchantData.cardImg} width={FORM_BUTTON_WIDTH} />
      <ImpSpacer height="xl" />
      <ImpText typography="headline3">{content.title}</ImpText>
      <ImpSpacer height="xs" />
      <ImpText typography="body2" color={colors.content.onSurfaceVariant}>
        {content.subtitle}
      </ImpText>
      <ImpSpacer height="xl" />
      <ImpContainer width={FORM_BUTTON_WIDTH}>
        <ImpList items={getListItemProps(content.listItems)} />
      </ImpContainer>
    </OnboardingLayout>
  );
}
